module.exports = __webpack_public_path__ + "static/media/activeinvesticon.4eb67f2d.svg";